function pdfDownloadAriaLabel() {
  const el = document.getElementsByTagName('a')
  el?.forEach(item => {
    if (item?.href?.includes('.pdf') || item?.href?.includes('.PDF')) {
      item?.setAttribute(
        'aria-label',
        item?.target === '_blank'
          ? item?.textContent + ' PDF Opens in new tab'
          : item?.textContent + ' PDF'
      )
    }
  })
}
document.addEventListener('DOMContentLoaded', pdfDownloadAriaLabel)
